import parse from "html-react-parser";
import { useRef, useState, useEffect } from "react";
import { useToasts } from "react-toast-notifications";
import Button from "../../../../Elements/Button/Button.js";
import Icon from "../../../../Elements/Icon/Icon.tsx";
import Dropdown from "../../../../Elements/Dropdown/Dropdown.js";
import apiRequest from "../../../../../utils/ApiRequest/apiRequest.js";
import config from "config";
import TrackerComponent from "./TrackerComponent.js";
import CreateEmbedPageModalNew from "../Modals/CreateEmbedPageModalNew.js";
import EmbedLimitOptionsModal from "../../../../Reusable/JUMBOform/Modals/EmbedLimitOptionsModal.js";
import LanguageChangedModal from "./LanguageChangedModal.js";
import Tooltip from "../../../../Elements/Tooltip/Tooltip.js";
import Recaptcha from "components/Reusable/Recaptcha/Recaptcha.tsx";
import { Toggle } from "../../../../Elements/Toggle/Toggle.js";
import { embedColorCode } from "components/Reusable/JUMBOform/ExternalJsonsList/JsonLists.js";
import { LinkToNewTab } from "../../../../Elements/Link/Link.js";
import { awaiter } from "components/Pages/Home/Helpers/helpers.js";
import { RECAPTCHA_APPEAR_DELAY } from "utils/globalConsts.ts";
import usePageInit from "hooks/usePageInit.ts";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import { useModal } from "../../../../../contexts/modalContext/modalContext.js";


const OrderTracker = ({ userData, availableAllPages, dynamicFormsList }) => {
  const {
    getTextByKey,
    getLanguageCulture,
    getDirection,
    getLanguage,
    getPath,
    getBasicSettingsData,
  } = useContent();
  const { setModal, closeModal } = useModal();
  const [exampleScript, setExampleScript] = useState("");
  const { addToast } = useToasts();
  const list = [
    "English - LTR",
    "עברית - RTL",
    "Pусский - LTR",
    "Italiano - LTR",
    "Español - LTR",
    "عربى - RTL",
  ];
  const shortList = ["en-US", "he-IL", "ru-RU", "it-IT", "es-ES", "ar-SA"];

  const [titleDropDown, settitleDropDown] = useState(
    list[shortList.indexOf(getLanguageCulture())]
  );
  const [scriptLanguage, setScriptLanguage] = useState(getLanguageCulture());
  const [shortLanguage, setShortLanguage] = useState(getLanguage());
  const textAreaRef = useRef(null);
  const [scriptOrIframe, setScriptOrIframe] = useState("script");
  const [enterEmbedCode, setEnterEmbedCode] = useState(false);
  const [orderTrackerColor, setOrderTrackerColor] = useState(embedColorCode);
  const [colorText, setColorText] = useState(embedColorCode);
  const [embedPremiumWithNoForms, setEmbedPremiumWithNoForms] = useState(false);
  const [userEmbedPage, setUserEmbedPage] = useState(null);
  const [displayInPersonalPage, setDisplayInPersonalPage] = useState(false);
  const [fetchOrderTracker, setFetchOrderTracker] = useState(false);
  const [defaultCulture, setDefaultCulture] = useState(
    list[shortList.indexOf(getLanguageCulture())]
  );
  const { isPageReady } = usePageInit();

  const [isCaptchaShown, setIsCaptchaShown] = useState(false);
  const [captchaToken, setCaptchaToken] = useState("");
  const recaptchaRef = useRef();
  const [submitData, setSubmitData] = useState({});

  useEffect(() => {
    if (captchaToken) {
      createEmbedPage(submitData);
      setCaptchaToken(null);
      setIsCaptchaShown(false);
    }
  }, [captchaToken, submitData]);

  const copyTextAreaToClibord = () => {
    textAreaRef.current.select();
    document.execCommand("copy");
  };
  //userEmbedPage ? userEmbedPage.EmbedPageShowOrderTracker ? true : false : false
  useEffect(() => {
    if (userData && userData.UserId !== undefined) {
      checkIfEmbedPageExistByUserId();
      getOrderTracker();
    }
  }, [userData]);

  //change the script if type or language changed
  useEffect(() => {
    getExampleScript(scriptOrIframe, scriptLanguage);
    const newShort = getShortLanguage(scriptLanguage);
    setShortLanguage(newShort);
  }, [scriptOrIframe, scriptLanguage]);

  const getShortLanguage = (language) => {
    switch (language) {
      case "en-US":
        return "en";
      case "he-IL":
        return "he";
      case "ru-RU":
        return "ru";
      case "it-IT":
        return "it";
      case "es-ES":
        return "es";
      case "ar-SA":
        return "ar";
      default:
        return "en";
    }
  };
  //set the script on load page
  useEffect(() => {}, []);

  const checkIfEmbedPageExistByUserId = async () => {
    const response = await apiRequest("EmbedDynamics", "GetEmbedPageByUserId");
    if (response.status === "success") {
      if (response.data) {
        setUserEmbedPage(response.data);
        setDisplayInPersonalPage(response.data.EmbedPageShowOrderTracker);
      }
    }
  };

  //choose language
  const handleChange = (e, itemKey) => {
    settitleDropDown(list[itemKey]);
    setScriptLanguage(shortList[itemKey]);
    getExampleScript(scriptOrIframe, shortList[itemKey]);
    updateOrderTracker({
      isActive: enterEmbedCode,
      languageTracker: shortList[itemKey],
    });
  };

  //get script from API
  const getExampleScript = async (type, language) => {
    setScriptOrIframe(type);
    const parameters = {
      typeScript: type,
      culture: language,
      formId: -1,
      formWidth: 400,
      formHeight: 170,
      serviceType: "follow",
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "CreateEmbedDynamicCodeReact",
      parameters
    );
    if (response.status === "success") {
      setExampleScript(response.data);
    }
  };

  const updateDisplayOrderTracker = () => {
    if (!embedPremiumWithNoForms) {
      if (availableAllPages) {
        if (userEmbedPage && userEmbedPage.EmbedPageUserName) {
          let addOrderTrackerToEmbedPage = !displayInPersonalPage;
          reactUpdateOrderTracker(addOrderTrackerToEmbedPage);
          setDisplayInPersonalPage((prev) => !prev);
        } else {
          addToast(getTextByKey("need-create-page"), {
            appearance: "error",
          });
        }
      } else {
        setModal(() => <EmbedLimitOptionsModal />);
      }
    }
  };

  const reactUpdateOrderTracker = async (showOrderTracker) => {
    const parameters = {
      embedPageUserName: userEmbedPage.EmbedPageUserName,
      status: showOrderTracker,
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "ReactUpdateOrderTracker",
      parameters
    );
    if (response.status === "success") {
    }
  };
  const createEmbedPage = async ({ companyName, activeFormLists }) => {
    if (!captchaToken) {
      setIsCaptchaShown(true);
      setSubmitData({ companyName, activeFormLists });
      if (getBasicSettingsData()?.recaptchaType === "google") {
        await awaiter(RECAPTCHA_APPEAR_DELAY);
        await recaptchaRef.current.executeAsync();
      }
      return;
    }

    const body = {
      Occupation: "",
      EmbedDynamicPageCompanyName: companyName.trim(),
      EmbedDynamicPageActive: true,
      EmbedDynamicPageDirection: getDirection(),
      EmbedPageCulture: getLanguageCulture(),
      ShortCulture: getLanguage(),
      EmbedDynamicPageFormIdsList: activeFormLists,
      isProfilePages: true,
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "CreateEmbedPageReact",
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data) {
        if (response.data.EmbedDybamicPageResponseCode === 0) {
          let embedPage =
            config.baseurl + getPath() + "page-edit/" + response.data.UserName;
          window.location.href = embedPage;
        } else if (response.data.EmbedDybamicPageResponseCode === 460017) {
          addToast(getTextByKey("embed-subscription-expired"), {
            appearance: "error",
          });
        } else {
          addToast(getTextByKey("global-error-toast"), {
            appearance: "error",
          });
        }
      }
    }
    closeModal();
  };

  const showEmbedCode = () => {
    if (!embedPremiumWithNoForms) {
      if (availableAllPages) {
        updateOrderTracker({
          isActive: !enterEmbedCode,
          languageTracker: scriptLanguage,
          showEmbedToggle: true,
        });
        setEnterEmbedCode((prev) => !prev);
      } else {
        setModal(() => <EmbedLimitOptionsModal />);
      }
    }
  };

  const updateOrderTracker = async ({
    isActive,
    languageTracker,
    showEmbedToggle,
  }) => {
    const body = {
      OrderTrackerLanguage: languageTracker,
      OrderTrackerActive: isActive,
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "CreateOrUpdateOrderTracker",
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data === 0) {
        if (!showEmbedToggle) {
          setModal(() => <LanguageChangedModal />);
        }
      }
    }
  };

  const updateOrderTrackerColor = async (color) => {
    const body = {
      OrderTrackerColor: color,
      OrderTrackerLanguage: scriptLanguage,
      OrderTrackerActive: true,
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "CreateOrUpdateOrderTrackerColor",
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data === 0) {
      }
    }
  };

  const getOrderTracker = async () => {
    const parameters = {
      encryptedUId: "null",
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "GetOrderTracker",
      parameters
    );
    if (response.status === "success") {
      if (response.data) {
        setDefaultCulture(
          list[shortList.indexOf(response.data.OrderTrackerLanguage)]
        );
        if (response.data.OrderTrackerColor) {
          setOrderTrackerColor(response.data.OrderTrackerColor);
          setColorText(response.data.OrderTrackerColor);
        }
        setScriptLanguage(response.data.OrderTrackerLanguage);
        getExampleScript("script", response.data.OrderTrackerLanguage);
        setEnterEmbedCode(response.data.OrderTrackerActive);
      } else {
        getExampleScript("script", getLanguageCulture());
        setDefaultCulture(list[shortList.indexOf(getLanguageCulture())]);
      }
    } else {
      getExampleScript("script", getLanguageCulture());
      setDefaultCulture(list[shortList.indexOf(getLanguageCulture())]);
    }
    setFetchOrderTracker(true);
  };

  useEffect(() => {
    if (
      availableAllPages &&
      (!dynamicFormsList || dynamicFormsList.length === 0)
    ) {
      setEmbedPremiumWithNoForms(true);
    } else {
      setEmbedPremiumWithNoForms(false);
    }
  }, [availableAllPages, dynamicFormsList]);

  const openCreatePageModal = () => {
    setModal(() => (
      <CreateEmbedPageModalNew
        dynamicFormsList={dynamicFormsList}
        createPage={createEmbedPage}
      />
    ));
  };

  const handleChangeBrandingColorText = (e) => {
    if (e.startsWith("#")) {
      setColorText(e);
    }
  };

  const handleBlurInputText = () => {
    //check if colorText is valid hex color
    const validColorCode = new RegExp("^#(?:[0-9a-fA-F]{3}){1,2}$");
    if (!validColorCode.test(colorText)) {
      setColorText(orderTrackerColor);
    } else {
      if (!embedPremiumWithNoForms) {
        if (availableAllPages) {
          if (orderTrackerColor !== colorText) {
            setOrderTrackerColor(colorText);
            updateOrderTrackerColor(colorText);
          }
        } else {
          setModal(() => <EmbedLimitOptionsModal />);
        }
      }
    }
  };

  const handleBlurColorInput = (e) => {
    updateOrderTrackerColor(orderTrackerColor);
  };

  if (!isPageReady) {
    return null;
  }

  return (
    <div className="order-container">
      {isCaptchaShown ? (
        <Recaptcha
          recaptchaRef={recaptchaRef}
          onSuccess={(token) => setCaptchaToken(token)}
        />
      ) : null}
      <div className="title-side embed-page-title">
        <h3>{getTextByKey("profile-menu-jumboform-order-tracker")}</h3>
        {embedPremiumWithNoForms && (
          <div className="create-new-form">
            <span className="text-span">
              {getTextByKey("order-tracker-create-form")}
            </span>{" "}
            <div className="create-new-forms-button">
              <LinkToNewTab isNewTab={true} page={"create-form"}>
                <Button tabIndex="-1" className="">
                  <Icon name={"plus"}></Icon>
                  <span>{getTextByKey("jumboforms-create-form")}</span>
                </Button>
              </LinkToNewTab>
            </div>
          </div>
        )}
      </div>
      <div className="order-main">
        <div
          className={`left-side ${
            embedPremiumWithNoForms ? "premium-no-forms" : ""
          }`}
        >
          <div
            className={`embed-code ${
              !availableAllPages || embedPremiumWithNoForms
                ? "only-premium"
                : ""
            }`}
          >
            <div className="toggle-div">
              <Toggle
                status={
                  embedPremiumWithNoForms
                    ? false
                    : availableAllPages
                    ? enterEmbedCode
                    : false
                }
                setStatus={showEmbedCode}
              />
              <span className="text-title">
                {getTextByKey("enter-embed-code")}
              </span>
            </div>
            <div className="embed-code-text">
              <p className="text-span">
                {parse(getTextByKey("order-tracker-sub-title"))}
              </p>
            </div>
            {availableAllPages &&
              !embedPremiumWithNoForms &&
              enterEmbedCode && (
                <>
                  <div className="lang-and-color">
                    <div className="choose-language">
                      <div className="form-language">
                        <span className="lang-text">
                          {getTextByKey("order-tracker-form-language")}{" "}
                        </span>

                        <Tooltip
                          id={"order-tracker-form-language"}
                          tooltipTextKey="order-tracker-form-language-tooltip"
                          //hardPositioned
                        >
                          <Icon
                            name="question-circle"
                            iconClass="tooltip-question"
                          />
                        </Tooltip>
                      </div>
                      <Dropdown
                        title={titleDropDown}
                        handleChange={handleChange}
                        selectList={list}
                        defaultValue={defaultCulture}
                      >
                        {" "}
                        <div className="">
                          <Icon name="arrow-down-solid" small />
                        </div>
                      </Dropdown>
                    </div>
                    <div className="choose-color">
                      <div className="color-text">
                        <span className="color-span">
                          {getTextByKey("order-tracker-color")}
                        </span>{" "}
                        <Tooltip
                          id={"order-tracker-color-tooltip"}
                          tooltipTextKey="order-tracker-color-tooltip"
                          //hardPositioned
                        >
                          <Icon
                            name="question-circle"
                            iconClass="tooltip-question"
                          />
                        </Tooltip>
                      </div>
                      <div className="input-color-div">
                        <div className="text-color">
                          <input
                            onBlur={handleBlurInputText}
                            type="text"
                            value={colorText}
                            onChange={(e) => {
                              handleChangeBrandingColorText(e.target.value);
                            }}
                          />
                        </div>
                        <div
                          className="background-color"
                          style={{ backgroundColor: orderTrackerColor }}
                        >
                          <input
                            onBlur={handleBlurColorInput}
                            value={orderTrackerColor}
                            onChange={(e) =>
                              setOrderTrackerColor(e.target.value)
                            }
                            type="color"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="form-script">
                    <div className="get-links">
                      <div className="type-links">
                        <span
                          onClick={() => {
                            getExampleScript("script");
                          }}
                          className={
                            scriptOrIframe === "script" ? "active" : ""
                          }
                        >
                          Script
                        </span>{" "}
                        <span
                          onClick={() => {
                            getExampleScript("iframe");
                          }}
                          className={
                            scriptOrIframe === "iframe" ? "active" : ""
                          }
                        >
                          Iframe
                        </span>
                      </div>
                      <div
                        className="copy-icon"
                        onClick={() => copyTextAreaToClibord()}
                      >
                        <Icon
                          title={getTextByKey("copy-embed-code")}
                          name="copy-b"
                        />
                      </div>
                    </div>
                    <div className="script-line">
                      <div className="script-code">
                        <textarea
                          ref={textAreaRef}
                          readOnly
                          //onChange={handleChangeTextarea}
                          value={exampleScript}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </>
              )}
          </div>
          <div className="display-personal-page">
            <div
              className={`toggle-div ${
                !availableAllPages ? "only-premium" : ""
              }`}
            >
              <Toggle
                status={
                  embedPremiumWithNoForms
                    ? false
                    : availableAllPages
                    ? displayInPersonalPage
                    : false
                }
                setStatus={updateDisplayOrderTracker}
              />
              <span className="text-title">
                {getTextByKey("display-order-tracker-toggle")}
              </span>
            </div>
            <div
              className={`display-order-tracker-text text-span ${
                !availableAllPages ? "only-premium" : ""
              }`}
            >
              {userEmbedPage
                ? getTextByKey("show-order-tracker-text-profile-pages")
                : getTextByKey("display-order-tracker-info")}
            </div>
            {userEmbedPage ? (
              <LinkToNewTab
                page={`page-edit/${userEmbedPage.EmbedPageUserName}`}
                isNewTab={true}
              >
                <Button className="order-tracker-button">
                  {getTextByKey("go-to-my-page-button")}
                </Button>
              </LinkToNewTab>
            ) : (
              <div onClick={() => openCreatePageModal()}>
                <Button className="order-tracker-button">
                  {getTextByKey("create-page")}
                </Button>
              </div>
            )}
          </div>
        </div>
        <div className="right-side">
          <div className="order-status">
            {shortLanguage && fetchOrderTracker && (
              <TrackerComponent
                language={shortLanguage}
                brandingColorExternal={
                  orderTrackerColor ? orderTrackerColor : "#febb29"
                }
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderTracker;
